
import pub_sub from "../../sim_3d/state/pub_sub"
import type { GetAppState, SetAppState } from "../interface"
import { SimulationStateInStore } from "./interface"


export function initial_state(set_state: SetAppState, get_state: GetAppState): SimulationStateInStore
{
    return {
        sim_state: undefined,
        set_sim_state: (new_sim_state) =>
        {
            set_state(state =>
            {
                state.simulation_state.sim_state = new_sim_state
            })
        },

        // Not yet convinced this is the correct pattern to use
        get_current_timesteps: () =>
        {
            const sim_state = get_state().simulation_state.sim_state
            if (!sim_state)
            {
                // console.error("Simulation state not set")
                return undefined
            }

            const payload = pub_sub.fetch_last_published_event("simulation_datetime")
            if (!payload)
            {
                console.error("No simulation_datetime event published yet")
                return undefined
            }

            const step1 = sim_state.timesteps[payload.datetime_sim_range_hourly_indices_mix.one]
            const step2 = sim_state.timesteps[payload.datetime_sim_range_hourly_indices_mix.two]

            if (!step1 || !step2)
            {
                console.error(`Simulation state does not have timesteps for the current datetime indices ${payload.datetime_sim_range_hourly_indices_mix.one} and ${payload.datetime_sim_range_hourly_indices_mix.two}`)
                return undefined
            }

            return { step1, step2, mix: payload.datetime_sim_range_hourly_indices_mix.mix }
        },
    }
}
